import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';
import Header from '../Header/Header';
import Routes from '../Routes';
import useStyles from '../useStyles';
import ScrollTop from '../ScrollTop';
import SendFeedbackDialog from '../SendFeedback/SendFeedbackDialog';
import ErrorModal from '../components/ErrorModal';
import MessagesEnUS from '../translations/en-US.json';
import MessagesEnGB from '../translations/en-GB.json';
import MessagesEsMX from '../translations/es-MX.json';
import LoadCurrencyPayScript from '../CurrencyPay/LoadCurrencyPayScript';
import LoadCurrencyPayConfig from '../CurrencyPay/LoadCurrencyPayConfig';
import LoadFortisScript from '../Fortis/LoadFortisScript';
import LoadFortisConfig from '../Fortis/LoadFortisConfig';
import ConfigureCurrencyPayWidget from '../CurrencyPay/ConfigureCurrencyPayWidget';

const InternationalizedApp = function InternationalizedApp(): React.ReactElement {
  const classes = useStyles();
  const culture = useSelector((state: iRootState) => state.quote.culture);

  let messages;
  switch (culture) {
    case 'es-MX':
      messages = MessagesEsMX;
      break;
    case 'en-GB':
      messages = MessagesEnGB;
      break;
    default:
      messages = MessagesEnUS;
      break;
  }

  return (
    <IntlProvider locale={culture} messages={messages}>
      <LoadCurrencyPayScript />
      <LoadCurrencyPayConfig />
      <LoadFortisScript />
      <LoadFortisConfig />
      <ConfigureCurrencyPayWidget />
      <Header />
      <div className={classes.menuBarOffset} id='back-to-top-anchor' />
      <Routes />
      <ScrollTop />
      <SendFeedbackDialog />
      <ErrorModal />
      <div className={classes.menuBarOffset} id='back-to-bottom-anchor' />
    </IntlProvider>
  );
};

export default InternationalizedApp;
